import Api from './Api';

class AppService {
  // ✅ For MOST places: returns App[]
  getAppsList = async (pageSize = 2000, search?: string | null, isPinned: boolean = false) => {
    const params: any = { pageNumber: 1, pageSize };
    // - isPinned=false => returns ALL apps (true + false)
    params.isPinned = isPinned;
    if (search) params.filter = search;

    const { data } = await Api.get('/v2/applications', { params });
    return data?.data ?? []; // <-- unwrap here
  };

  // ✅ For App Switcher / infinite scroll: returns { data: App[], hasNextPage: boolean }
  getAppsPaged = async (
    pageNumber: number,
    pageSize: number,
    search?: string | null,
    isPinned: boolean = false,
    //  default to false
  ) => {
    const params: any = { pageNumber, pageSize };

    // ⚠️ IMPORTANT:
    // BE BUG/BEHAVIOR:
    // - isPinned=false => returns ALL apps (true + false)
    // - isPinned=true  => returns ONLY pinned apps
    // So we ALWAYS pass false for the main list
    params.isPinned = isPinned;

    if (search) params.search = search;

    const { data } = await Api.get('/v2/applications', { params });
    return data;
  };
}

export { AppService };
export default new AppService();
